import type { IconAdornmentProps } from '@gokrew/models/ui.types';

export interface IconAdornmentComponentProps extends IconAdornmentProps {
  children: React.ReactNode;
  error?: string;
  onIconClick?: () => void;
}
export function IconAdornment({
  IconPrefix,
  IconSuffix,
  onIconClick,
  children,
}: IconAdornmentComponentProps) {
  return (
    <div className="relative w-full">
      {IconPrefix && (
        <IconPrefix
          size={20}
          className="absolute text-gray-400 ml-3 top-1/2 left-0 -translate-y-1/2"
        />
      )}

      {children}

      {IconSuffix && (
        <IconSuffix
          size={20}
          className="absolute text-gray-400 mr-3 top-1/2 right-0 -translate-y-1/2"
          onClick={onIconClick}
        />
      )}
    </div>
  );
}
